export default function ($locationProvider, $translateProvider, $translatePartialLoaderProvider, $logProvider, $provide, $windowProvider) {
  'ngInject';

  if (!process.env.isDev) {
    $logProvider.debugEnabled(false);
    $provide.decorator('$log', ($delegate) => {
      'ngInject';
      $delegate.warn = angular.noop;
      $delegate.info = angular.noop;
      $delegate.error = angular.noop;
      $delegate.log = angular.noop;
      return $delegate;
    });
  }

  // Disabled because we don't have control over the server rewrites
  const $window = $windowProvider.$get();
  if (!$window.innerWidth < 1024) {
    $locationProvider.html5Mode(true).hashPrefix('!'); // Use the HTML5 History API
  }

  $translateProvider.useSanitizeValueStrategy('sce');
  $translatePartialLoaderProvider.addPart('common');

  $translateProvider.useLoader('$translatePartialLoader', {
    urlTemplate: 'app/{part}/i18n/{lang}.json',
  });

  $translateProvider.preferredLanguage('es');
}



// WEBPACK FOOTER //
// ./client/app/app.config.js